import React, { useState } from 'react';

import { Box, TextField, IconButton } from '@material-ui/core';
import { Save as SaveIcon } from '@material-ui/icons';
const EditTextInRow = ({ fieldName, value, saveValue }) => {
  const [formValue, setformValue] = useState(value);

  return (
    <Box>
      <TextField onChange={({ target: { value: v } }) => setformValue(v)} value={formValue} />
      <IconButton onClick={() => saveValue({ [fieldName]: formValue })}>
        <SaveIcon />
      </IconButton>
    </Box>
  );
};

export default EditTextInRow;
